<template>
  <div class="img-upload-wrapper">
    <el-row :gutter="20">
      <!-- 拖拽排序图片列表 -->
      <draggable v-model="imgList" @end="draggableChange" animation="300" v-if="!is_draggable">
        <el-col
          :span="6"
          v-for="(img, index) in imgList"
          :key="img.index"
          class="img-min"
        >
          <div class="grid-content bg-purple">
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              size="mini"
              class="remove"
              @click="remove(index)"
            ></el-button>
            <el-image
              style="width: 100%; height: 100%"
              :src="img.url"
              fit="cover"
            >
            </el-image>

            <!-- 上传进度条 -->
            <div class="progress" v-show="img.percentage !== 100">
              <el-progress
                type="circle"
                :width="80"
                text-color="white"
                :percentage="parseInt(img.percentage)"
              ></el-progress>
            </div>
          </div>
          <div class="title">
            <p v-if="!img.is_edit" @click="onEditTitle(img, index)">
              {{ img.name }}
            </p>
            <el-input
              placeholder="请输入标题"
              v-model="img.name"
              v-else
              size="mini"
            >
              <el-button
                slot="append"
                icon="el-icon-check"
                size="mini"
                @click="onEditTitle(img, index)"
              ></el-button>
            </el-input>
          </div>
        </el-col>
      </draggable>

      <!-- 已上传图片列表 -->
      <!-- <div v-show="is_draggable">
        <el-col
          :span="6"
          v-for="(img, index) in imgList"
          :key="img.index"
          class="img-min"
        >
          <div class="grid-content bg-purple">
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              size="mini"
              class="remove"
              @click="remove(index)"
            ></el-button>
            <el-image
              style="width: 100%; height: 100%"
              :src="img.url"
              fit="cover"
            >
            </el-image>
            <div class="progress" v-show="img.percentage !== 100">
              <el-progress
                type="circle"
                :percentage="parseInt(img.percentage)"
              ></el-progress>
            </div>
          </div>
          <div class="title">
            <p v-if="!img.is_edit" @click="onEditTitle(img, index)">
              {{ img.name }}
            </p>
            <el-input
              placeholder="请输入标题"
              v-model="img.name"
              v-else
              size="mini"
            >
              <el-button
                slot="append"
                icon="el-icon-check"
                size="mini"
                @click="onEditTitle(img, index)"
              ></el-button>
            </el-input>
          </div>
        </el-col>
      </div> -->

      <!-- 上传图片 -->
      <el-col :span="6" class="img-min" v-show="!is_draggable">
        <el-upload
          :action="actionUrl"
          list-type="picture-card"
          accept="image/jpg,image/jpeg,image/png"
          :multiple="true"
          :on-success="handleSuccess"
          :file-list="imgList"
          :on-progress="handleProgress"
          :on-change="handleSelect"
          :on-exceed="handleError"
          :show-file-list="false"
          :headers="postHeader"
          class="upload w-100"
          :limit="maxLength"
          :before-upload="beforeUpload"
        >
          <i slot="default" class="el-icon-plus"></i>
        </el-upload>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import TitleItem from "./title.vue";
import { mapState } from "vuex";
export default {
  components: {
    draggable,
    TitleItem,
  },
  props: {
    maxLength: {
      type: Number,
      default: 1000,
    },
  },
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      actionUrl: "/api/v3/material/upload/",
      imgList: [],
      drag: false,
      is_draggable: false,
      uploadHeaders: {},
      is_message: false
    };
  },
  computed: mapState({
    postHeader: (state) => {
      return {
        Authorization: state.token,
      };
    },
  }),
  methods: {
    handleRemove(file) {
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSelect(file, fileList) {
      file.is_edit = false;
      file.is_show = false;
      this.$emit("OnImgChange", fileList);
    },
    handleSuccess(res, file, fileList) {
      if (res) {
        file.response_url = res.url;
        this.$emit("OnImgChange", this.imgList);
      }
    },
    handleProgress(e, file, fileList) {
      this.imgList = fileList;
    },
    handleError(err) {
      this.$notify({
        title: "提示",
        message: `最多只能上传${this.maxLength}张图片`,
        type: "warning",
      });
    },
    //开始拖拽事件
    onStart() {
      this.drag = true;
    },
    //拖拽结束事件
    onEnd() {
      this.drag = false;
      this.$emit("OnImgChange", this.imgList);
    },
    // 图片标题修改
    onEditTitle(imgData, index) {
      this.imgList.forEach((item) => {
        if (item.uid !== imgData.uid) item.is_edit = false;
      });
      if (imgData.name === "") {
        this.$notify({
          title: "提示",
          message: "图片名称不得为空！",
        });
        return;
      }
      imgData.is_edit ? (imgData.is_edit = false) : (imgData.is_edit = true);
      imgData.percentage = imgData.percentage++;
      this.$emit("OnImgChange", this.imgList);
    },
    // 清空数据
    clearList() {
      this.imgList = [];
    },
    draggableChange (e) {
      this.$emit("OnImgChange", this.imgList);
    },
    remove(index) {
      this.imgList.splice(index, 1);
      this.$emit("OnImgChange", this.imgList);
    },
    beforeUpload (file) {
      return new Promise((resolve, reject) => {
        const isLt1M = file.size / 1024 / 1024 < 10
        if (!isLt1M) {
          if (!this.is_message) {
            this.is_message = true
            this.$message.error({message: '上传图片大小不能超过 10MB!', duration: 1000, onClose: () => {
              this.is_message = false 
            }})
          }
          return reject(false)
        } else {
          return resolve(true)
        }
      })
    }
  },
};
</script>
<style  scoped>
.img-upload-wrapper {
  text-align: left;
  position: absolute;
  min-height: 50px;
  width: 100%;
  top: 80px;
  bottom: 40px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.img-min {
  margin-bottom: 20px;
  cursor: move;
}
.img-min .title {
  margin-top: 5px;
  height: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.img-min .title p {
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 14px;
}
.img-min .title .el-input__inner {
  padding: 0 5px !important;
}
.img-min .progress {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(34, 34, 34, 0.2);
}
.img-min .grid-content,
.img-min .upload {
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}
.remove {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 22;
}
.img-min .grid-content .el-image {
  height: 100%;
  position: absolute;
}
</style>